import Seo from '@/components/feature/Seo';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import NewsBrief from '@/pages/home/components/NewsBrief';
import FeaturedWorks from '@/pages/home/components/FeaturedWorks';
import ProfileTeaser from '@/pages/home/components/ProfileTeaser';

export default function Home() {
  return (
    <>
      <Seo
        title="深田咏美明星资讯大全-最新作品与新闻动态"
        description="深田咏美官方网站，提供全面的深田咏美资讯、最新作品介绍及相关动态。浏览明星资料，了解她的影视作品和活动信息。"
        keywords="深田咏美,深田咏美作品,深田咏美资讯,深田咏美动态,深田咏美影视,深田咏美新闻,深田咏美资料"
      />
      <HeroCarousel />
      <NewsBrief />
      <FeaturedWorks />
      <ProfileTeaser />
    </>
  );
}